import React from 'react';
import phrasesType from '../proptypes/phrases';

const VisitHQ = ({ phrases }) => (
  <div className="visit-hq">
    <div className="row justify-content-center">
      <div className="col-12 text-center">
        <h3 className="visit-hq__title mt-2 mb-3">{phrases.title}</h3>
      </div>
    </div>
    <div className="row justify-content-center">
      <div className="col-12 col-lg-5 text-center">
        <p className="visit-hq__description mb-3">{phrases.description}</p>
      </div>
    </div>
    <div className="row justify-content-center">
      <div className="col-8 col-lg-4 text-center">
        <a className="visit-hq__link" href="/nyc/visit">{phrases.link}</a>
      </div>
    </div>
  </div>
);

VisitHQ.propTypes = {
  phrases: phrasesType.isRequired,
};

export default VisitHQ;
